// extracted by mini-css-extract-plugin
module.exports = {"audioBlock":"style_audioBlock__C43XC","embed":"style_embed__F_KT3","providerLinks":"style_providerLinks__DTQpJ"};